// Mensagem do envio de certificado a partir da resposta do backend. Antes a tela
// mostrava "Senha do certificado inválida!" para qualquer erro, inclusive o 401
// do link vencido e o 403 de empresa trocada (conducco-admin-backend#2022).

// Texto que o backend manda quando a senha do .pfx nao abre o arquivo
// (`upload-certificate/utils/certificate-validator.ts`).
export const CERTIFICATE_PASSWORD_MESSAGE = 'Senha do certificado inválida!'

export const GUEST_LINK_EXPIRED_MESSAGE = 'O link do convite expirou; peça um novo a quem o enviou.'
export const SESSION_EXPIRED_MESSAGE = 'Sua sessão expirou; entre de novo e tente outra vez.'
export const OTHER_COMPANY_MESSAGE = 'Este link é de outra empresa.'
export const GENERIC_MESSAGE = 'Algo deu errado, tente novamente mais tarde!'

interface IUploadErrorLike {
  response?: {
    status?: number
    data?: { data?: { message?: string } }
  }
}

export const uploadErrorMessage = (err: unknown, isGuest: boolean): string => {
  const response = (err as IUploadErrorLike | undefined)?.response

  if (response?.status === 401) {
    return isGuest ? GUEST_LINK_EXPIRED_MESSAGE : SESSION_EXPIRED_MESSAGE
  }

  if (response?.status === 403) {
    return OTHER_COMPANY_MESSAGE
  }

  if (response?.data?.data?.message === CERTIFICATE_PASSWORD_MESSAGE) {
    return CERTIFICATE_PASSWORD_MESSAGE
  }

  return GENERIC_MESSAGE
}
